'use client';

import type { SignalStageType } from '@terra/shared-schemas-orchestrator';
import { useTranslations } from 'next-intl';
import { useSignalsStageCounts } from '../../hooks/dashboard/useSignalsStageCounts';
import { buildSignalStagePostureItems } from './posture-items';
import { PostureCard } from './PostureCard';
import { useOpenListFromHome } from './useOpenListFromHome';

type SignalsStagePostureCardProps = {
  applicationId: string;
};

export function SignalsStagePostureCard({
  applicationId,
}: SignalsStagePostureCardProps) {
  const t = useTranslations('home.posture');
  const tStage = useTranslations('designSystem.signals.lifecycle.stage');
  const { data, isLoading } = useSignalsStageCounts(applicationId);
  const { openList, openListContextMenu } = useOpenListFromHome({
    applicationId,
  });
  const items = buildSignalStagePostureItems({
    counts: data?.byStage ?? {
      NEW: 0,
      IN_TESTING: 0,
      NEEDS_REVIEW: 0,
      TESTED: 0,
    },
  }).map((item) => ({ ...item, label: tStage(item.key) }));

  return (
    <PostureCard<SignalStageType>
      title={t('signalsByStage')}
      total={data?.total ?? 0}
      items={items}
      isLoading={isLoading}
      emptyLabel={t('noSignals')}
      onSelect={(stage) =>
        openList({ list: 'signals', filters: { stageFilter: [stage] } })
      }
      onTitleClick={() =>
        openList({ list: 'signals', filters: { stageFilter: [] } })
      }
      onTitleContextMenu={(event) =>
        openListContextMenu(event, { list: 'signals' })
      }
    />
  );
}
